<p-drawer
  [(visible)]="visible"
  (onHide)="closeModal()"
  [blockScroll]="true"
  styleClass="p-drawer-lg"
  position="right"
  [baseZIndex]="1000001"
>

  <ng-template pTemplate="header">
    <h3>{{ "data_location_modal_title" | i18n }}</h3>
  </ng-template>
  <div class="p-6">
    <div class="col-12 md:col-10 md:col-offset-1">

      <p-table styleClass="p-datatable-striped p-datatable-gridlines p-datatable-responsive-stack"
               responsiveLayout="stack"
               [tableStyle]="{ borderTop: '1px solid var(--border-datatable-td)'}"
               [value]="locationData"
      >
        <ng-template pTemplate="header"></ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.label | i18n }}</td>
            <td>{{ item.value | i18n }}</td>
          </tr>
        </ng-template>
      </p-table>

      <p-message severity="info">
          <span class="custom-message">{{'data_location_no_transfer_outside_eu' | i18n}}</span>
</p-message>

    </div>
    <div class="text-end p-drawer-toolbar-fixed">
      <p-button type="button" [label]="'button_close' | i18n" [outlined]="true"  styleClass="p-button-outlined p-button-secondary" (onClick)="closeModal()"></p-button>
    </div>
  </div>
</p-drawer>
